export const API = {
  common: {
    // 上传图片
    batchFileload: '/common/file/batchFileload.json',
  },
  cms: {
    queryAreaByAccountName: 'cms/area/queryAreaByAccountName.json',
  },
  bas: {
    closeTaskInfo: '/bas/taskcenter/closeTaskInfo.json',
    urgeTaskInfo: '/bas/taskcenter/urgeTaskInfo.json',
    countTaskNum: '/bas/taskcenter/countTaskNum.json',
    queryHisTaskInfo: '/bas/taskcenter/queryHisTaskInfo.json',
    queryUndoTaskInfo: '/bas/taskcenter/queryUndoTaskInfo.json',
    queryTaskInfo: '/bas/taskcenter/queryTaskInfo.json',
    queryAllTaskInfo: '/bas/taskcenter/queryAllTaskInfo.json',
    queryChecktaskInfo: 'bas/taskcenter/queryChecktaskInfo.json', //审核查询
    deleteTaskInfo: '/bas/taskcenter/deleteTaskInfo.json',
    startTaskInfo: '/bas/taskcenter/startTaskInfo.json',
    checkTaskInfo: 'bas/taskcenter/checkTaskInfo.json',//任务导出
    updateTaskInfo: '/bas/taskcenter/updateTaskInfo.json',
    addTaskInfo: '/bas/taskcenter/addTaskInfo.json',
    exportTask: '/bas/taskcenter/exportTask.json',  //任务导出
    batchUrgeTaskInfo: '/bas/taskcenter/batchUrgeTaskInfo.json',  //批量催办
    forwardTaskInfo: '/bas/taskcenter/forwardTaskInfo.json',  //转发
  },
  bms: {
    queryResource: '/bms/device/queryResource.json'
  },
  alarm: {
    queryAlarmDetail: '/bas/alarmSafeEvent/queryResult.json', //查询告警详情
  },
}
